/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './device.reducer';

export const DeviceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const deviceEntity = useAppSelector(state => state.device.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.device.detail.title">Device</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.device.id">Id</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.device.code">Code</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.code}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.device.description">Description</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.description}</dd>
          <dt>
            <span id="implant">
              <Translate contentKey="tinyMedicRestApp.device.implant">Implant</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.implant ? 'true' : 'false'}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.device.name">Name</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.name}</dd>
          <dt>
            <span id="mfgCode">
              <Translate contentKey="tinyMedicRestApp.device.mfgCode">Mfg Code</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.mfgCode}</dd>
          <dt>
            <span id="riskClass">
              <Translate contentKey="tinyMedicRestApp.device.riskClass">Risk Class</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.riskClass}</dd>
          <dt>
            <span id="slug">
              <Translate contentKey="tinyMedicRestApp.device.slug">Slug</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.slug}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.device.country">Country</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.country}</dd>
          <dt>
            <span id="releaseDate">
              <Translate contentKey="tinyMedicRestApp.device.releaseDate">Release Date</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.releaseDate}</dd>
          <dt>
            <span id="updatedDate">
              <Translate contentKey="tinyMedicRestApp.device.updatedDate">Updated Date</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.updatedDate}</dd>
          <dt>
            <span id="discontinued">
              <Translate contentKey="tinyMedicRestApp.device.discontinued">Discontinued</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.discontinued ? 'true' : 'false'}</dd>
          <dt>
            <span id="discontinuedDate">
              <Translate contentKey="tinyMedicRestApp.device.discontinuedDate">Discontinued Date</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.discontinuedDate}</dd>
          <dt>
            <span id="mrp">
              <Translate contentKey="tinyMedicRestApp.device.mrp">Mrp</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.mrp}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.device.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.device.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.device.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.device.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.device.active">Active</Translate>
            </span>
          </dt>
          <dd>{deviceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.device.classification">Classification</Translate>
          </dt>
          <dd>{deviceEntity.classification ? deviceEntity.classification.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.device.manufacturer">Manufacturer</Translate>
          </dt>
          <dd>{deviceEntity.manufacturer ? deviceEntity.manufacturer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.device.hospital">Hospital</Translate>
          </dt>
          <dd>{deviceEntity.hospital ? deviceEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/device" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device/${deviceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceDetail;
